import React, { Component } from 'react';
import { BUTTON_IDS } from '../../reducers/ui/buttons';

// Reusable logic for buttons that need to be protected from multiple clicks before network request completes.
// See Forward/Take buttons and Send message button for examples on how to use this HOC.
export const disableMultipleClicks = (WrappedComponent) => {
  return class extends Component {
    timeoutId = '';

    handleClick = () => {
      const { buttonId, setBtnActivity, clickAction } = this.props;
      if (setBtnActivity && buttonId && buttonId !== BUTTON_IDS.sendMessageBtn) {
        setBtnActivity(buttonId, false);
        this.timeoutId = setTimeout(() => {
          setBtnActivity(buttonId, true);
        }, 5000);
      }
      if (clickAction) {
        clickAction(buttonId);
      }
    };

    render() {
      return <WrappedComponent onClick={this.props.active ? this.handleClick : null} {...this.props} />;
    }
  };
};
